var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"storage"},[_c('div',{staticClass:"bgcBox"},[_c('div',{staticClass:"storage-item-echart"},[_c('Echart',{attrs:{"option":_vm.DryOption}})],1)]),_c('div',{staticClass:"honggan"},[_vm._v(" 正在加工:"+_vm._s(_vm.dun)+"吨 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }